import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Button, ButtonGroup } from "reactstrap";
import getDefaultUserPreferences from "../../_helpers/defaultUserPreferences";
import { getTimeOptions } from "../../_utils/generalUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import userActions from "../../_actions/userActions";
import mainTabActions from "../../_actions/mainTabActions";

class UserPreferences extends Component {
  state = {
    isChanged: false,
    selectedSection: "adr",
    accessibility: {
      mode: "light",
      fontSize: "normal",
    },
    notifications: {},
    adr: {
      shiftHours: {
        inputStyle: "dropdown",
        contractorStartShift: "0630",
        contractorEndShift: "1500",
        engineerStartShift: "0700",
        engineerEndShift: "1530",
      },
      crews: {
        inputStyle: "dropdown",
      },
      copy: {
        includeWorkDesc: false,
        includeHours: false,
        includeGenComments: false,
      },
      testsPerformed: {
        testsPerformedIds: [],
      },
    },
  };

  timeOptions = getTimeOptions();

  componentDidMount() {
    const { userPreferences: userPrefsFromProps } = this.props;

    let userPrefsToEdit = _.cloneDeep(this.state);
    if (!userPrefsFromProps) userPrefsToEdit = getDefaultUserPreferences();
    else this.copyPreferences(userPrefsToEdit, userPrefsFromProps);

    this.setState({ ...userPrefsToEdit });
  }

  /**
   * Takes user preferences from props (incomingPrefs) and selectively copies
   * only the sections and subsections (object keys) that match prefsToUpdate
   * (which is the state of this component). It directly modifies prefsToUpdate.
   * Uses recursion.
   * @param {Object} prefsToUpdate - initial state to update
   * @param {Object} incomingPrefs - incoming prefs
   */
  copyPreferences = (prefsToUpdate, incomingPrefs) => {
    for (const section in prefsToUpdate) {
      if (incomingPrefs[section]) {
        if (typeof incomingPrefs[section] === "object") {
          // Treat arrays as configuration value, not a nested subsection -
          // therefore deep-copy the value into prefsToUpdate
          if (Array.isArray(incomingPrefs[section]))
            prefsToUpdate[section] = _.cloneDeep(incomingPrefs[section]);
          // If not, recursively copy subsections
          else this.copyPreferences(prefsToUpdate[section], incomingPrefs[section]);
        } else prefsToUpdate[section] = incomingPrefs[section];
      }
    }
  };

  updateAdrPrefs = (section, fieldName) => (fieldValue) => {
    this.setState(
      {
        isChanged: true,
        adr: {
          ...this.state.adr,
          [section]: { ...this.state.adr[section], [fieldName]: fieldValue },
        },
      },
      this.props.markTabDirty
    );
  };

  handleClick_section = (selectedSection) => (e) => {
    e.preventDefault();
    this.setState({ selectedSection });
  };

  handleClick_save = (e) => {
    e.preventDefault();
    const { isChanged, selectedSection, ...prefsToUpdate } = this.state;
    this.props.update(prefsToUpdate);
    this.setState({ isChanged: false });
  };

  handleClick_close = (e) => {
    e.preventDefault();
    this.props.closeTab();
  };

  renderNotificationPrefs = () => {
    const { notifications } = this.state;
    return (
      <React.Fragment>
        <h4 className="mb-0 text-muted">Email</h4>
      </React.Fragment>
    );
  };

  renderAdrPrefs = () => {
    const { adr } = this.state;
    return (
      <React.Fragment>
        <h4 className="mb-0 text-muted">Shift Hours</h4>
        <hr className="my-2" />
        <ConfigButtonGroup
          update={this.updateAdrPrefs("shiftHours", "inputStyle")}
          state={adr.shiftHours.inputStyle}
          label="Default Input Style:"
          options={[
            { id: "dropdown", label: "Dropdown" },
            { id: "slider", label: "Time Slider" },
          ]}
        />
        <ConfigDropdown
          update={this.updateAdrPrefs("shiftHours", "contractorStartShift")}
          state={this.timeOptions.find(
            (to) => to.value === adr.shiftHours.contractorStartShift
          )}
          options={this.timeOptions}
          className="w-25"
          label="Contractor Start:"
          id="contractorStartShift"
        />
        <ConfigDropdown
          update={this.updateAdrPrefs("shiftHours", "contractorEndShift")}
          state={this.timeOptions.find(
            (to) => to.value === adr.shiftHours.contractorEndShift
          )}
          options={this.timeOptions}
          className="w-25"
          label="Contractor End:"
          id="contractorEndShift"
        />
        <ConfigDropdown
          update={this.updateAdrPrefs("shiftHours", "engineerStartShift")}
          state={this.timeOptions.find(
            (to) => to.value === adr.shiftHours.engineerStartShift
          )}
          options={this.timeOptions}
          className="w-25"
          label="Engineer Start:"
          id="engineerStartShift"
        />
        <ConfigDropdown
          update={this.updateAdrPrefs("shiftHours", "engineerEndShift")}
          state={this.timeOptions.find(
            (to) => to.value === adr.shiftHours.engineerEndShift
          )}
          options={this.timeOptions}
          className="w-25"
          label="Engineer End:"
          id="engineerEndShift"
        />
        <h4 className="mb-0 mt-4 text-muted">Crews</h4>
        <hr className="my-2" />
        <ConfigButtonGroup
          update={this.updateAdrPrefs("crews", "inputStyle")}
          state={adr.crews.inputStyle}
          label="Time Input Style:"
          options={[
            { id: "dropdown", label: "Dropdown" },
            { id: "select", label: "List Select" },
          ]}
        />
        <h4 className="mb-0 mt-4 text-muted">Copy</h4>
        <hr className="my-2" />
        <ConfigCheck
          update={this.updateAdrPrefs("copy", "includeWorkDesc")}
          state={adr.copy.includeWorkDesc}
          label="Copy work description (at each item/location)"
          id="includeWorkDesc"
        />
        <ConfigCheck
          update={this.updateAdrPrefs("copy", "includeHours")}
          state={adr.copy.includeHours}
          label="Copy labor/equipment hours"
          id="includeHours"
        />
        <ConfigCheck
          update={this.updateAdrPrefs("copy", "includeComments")}
          state={adr.copy.includeGenComments}
          label="Copy general comments"
          id="includeComments"
        />
      </React.Fragment>
    );
  };

  renderPreferences = () => {
    const { selectedSection } = this.state;
    switch (selectedSection) {
      case "notifications":
        return this.renderNotificationPrefs();
      case "adr":
        return this.renderAdrPrefs();
      default:
        break;
    }
  };

  render() {
    const { isChanged, selectedSection } = this.state;
    return (
      <React.Fragment>
        <div className="row w-100 m-0 px-2 pt-3 pb-0">
          {isChanged && <ModifiedAlert />}
        </div>
        <div className="row w-100 m-0 p-2">
          <div className="col-md-3 px-0">
            <ul className="list-group pointer-cursor">
              <li className="list-group-item disabled">Appearance</li>
              <li
                className={`list-group-item ${
                  selectedSection === "notifications" && "active"
                }`}
                onClick={this.handleClick_section("notifications")}
              >
                Notifications
              </li>
              <li
                className={`list-group-item ${selectedSection === "adr" && "active"}`}
                onClick={this.handleClick_section("adr")}
              >
                Assist. RE/SR Daily Reports
              </li>
            </ul>
          </div>
          <div className="col-md-9 pl-2 pr-0">
            <div className="card-body p-3">{this.renderPreferences()}</div>
          </div>
        </div>
        <div className="row w-100 m-0 pb-3 px-2 pt-0">
          <div className="card w-100">
            <div className="card-body bg-lightgray">
              <div className="form-row form-group float-right mb-0">
                <button
                  type="button"
                  id="saveUserPreferences"
                  name="saveUserPreferences"
                  className="btn btn-primary mr-3 px-4"
                  onClick={this.handleClick_save}
                >
                  <b>Save</b>
                </button>
                <button
                  type="button"
                  id="closeUserPreferences"
                  name="closeUserPreferences"
                  className="btn btn-secondary"
                  onClick={this.handleClick_close}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  userPreferences: state.authentication.user.userPreferences,
});

const mapDispactchToProps = (dispatch, ownProps) => ({
  closeTab: () => dispatch(mainTabActions.closeTab(ownProps.tabId)),
  update: (updatedUserPrefs) => dispatch(userActions.updateUserPrefs(updatedUserPrefs)),
  markTabDirty: () => dispatch(mainTabActions.markTabContentDirty(ownProps.tabId)),
});

export default connect(mapStateToProps, mapDispactchToProps)(UserPreferences);

const ModifiedAlert = () => {
  return (
    <div className="alert alert-warning w-100 my-0 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
      Changes have been made. Please remember to save before closing.
    </div>
  );
};

function ConfigButtonGroup(props) {
  const handleClick = (e) => {
    e.preventDefault();
    props.update(e.target.name);
  };

  return (
    <div className="form-row form-group mb-2">
      <label className="col-sm-3 col-form-label">{props.label}</label>
      <div className="col-sm-9">
        <ButtonGroup>
          {props.options.map((o, index) => (
            <Button
              key={`userPrefConfig_${o.id}_${index}`}
              name={o.id}
              id={`userPrefConfig_${o.id}_${index}`}
              color="primary"
              outline
              onClick={handleClick}
              active={props.state === o.id}
            >
              {props.state === o.id ? <b>{o.label}</b> : o.label}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </div>
  );
}

function ConfigCheck(props) {
  const handleChange = (e) => props.update(e.target.checked);

  return (
    <div className="form-row form-group mb-2">
      <div className="custom-control-inline custom-control custom-checkbox">
        <input
          type="checkbox"
          name={props.id}
          id={props.id}
          className="custom-control-input my-auto"
          value={props.state}
          checked={props.state}
          onChange={handleChange}
        />
        <label htmlFor={props.id} className="custom-control-label my-auto">
          {props.label}
        </label>
      </div>
    </div>
  );
}

function ConfigDropdown(props) {
  const handleChange = (selectedOption) => props.update(selectedOption.value);

  return (
    <div className="form-row form-group mb-2">
      <label className="col-sm-3 col-form-label">{props.label}</label>
      <div className="col-sm-9">
        <Select
          name={props.id}
          id={props.id}
          className={props.className}
          value={props.state}
          options={props.options}
          onChange={handleChange}
          styles={{
            // Fixes the overlapping problem of the component
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
        />
      </div>
    </div>
  );
}
